import React from 'react';

import { ExportErrorAlert } from 'components/ResultsExport/ExportErrorAlert';
import { buildExportErrorReport, describeExportFailure } from 'services/export/exportErrorReport';
import { WorkflowExportKind, workflowRunsFailedNote } from 'services/export/workflowExportSource';

interface WorkflowRunsErrorAlertProps {
  kind: WorkflowExportKind;
  studyId?: string;
  labId?: string;
  error?: unknown;
}

// The post-processing run list failed. Shows the HTTP status and the support details wherever the export is chosen.
export const WorkflowRunsErrorAlert: React.FC<WorkflowRunsErrorAlertProps> = ({ kind, studyId, labId, error }) => {
  const failure = describeExportFailure(error, workflowRunsFailedNote);
  return (
    <ExportErrorAlert
      title="The post-processing runs could not be loaded"
      errors={[failure]}
      report={buildExportErrorReport({
        operation: kind === 'features' ? 'Export features (list runs)' : 'Export cell tables (list runs)',
        studyId,
        labId,
        source: 'Post-processing run list',
        errors: [failure],
      })}
    />
  );
};
